module.exports = __webpack_public_path__ + "static/media/list.740fcf4f.webp";